import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@frontend/features/auth/hooks/useAuth';

/** Restore a scroll surface only after its initial content has loaded. */
export const useRememberedScroll = (ready: boolean, section = '') => {
  const ref = useRef<HTMLDivElement>(null);
  const { myProfile } = useAuth();
  const { pathname, search } = useLocation();
  const key = `page-scroll:${myProfile?.id}:${pathname}${search}:${section}`;

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element || !ready || !myProfile?.id) return;
    try {
      const saved = Number(sessionStorage.getItem(key));
      element.scrollTop = Number.isFinite(saved) && saved > 0 ? saved : 0;
    } catch {
      element.scrollTop = 0;
    }
    const remember = () => {
      try {
        sessionStorage.setItem(key, String(element.scrollTop));
      } catch {
        /* Storage is optional. */
      }
    };
    element.addEventListener('scroll', remember, { passive: true });
    return () => element.removeEventListener('scroll', remember);
  }, [key, ready, myProfile?.id]);

  return ref;
};
